// extracted by mini-css-extract-plugin
module.exports = {"brandSelector":"BrandSelector_brandSelector__NYjYv","title":"BrandSelector_title__1fACO"};